"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var lodash_1 = require("lodash");
var mobx_react_1 = require("mobx-react");
var ItemTypes_1 = require("QuoteV2/Models/ItemTypes");
var QuoteBlockStore_1 = __importDefault(require("QuoteV2/Stores/QuoteBlockStore"));
var QuoteItemStore_1 = require("QuoteV2/Stores/QuoteItemStore");
var react_1 = __importDefault(require("react"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var SavedLineItemsLibrary_1 = __importDefault(require("../SavedLineItems/SavedLineItemsLibrary"));
var QuoteProductLoader_1 = require("../QuoteProductStore/QuoteProductLoader");
var QuoteProductStore_1 = require("../QuoteProductStore/QuoteProductStore");
var mobx_1 = require("mobx");
var QuoteProductItemBuilder_1 = __importDefault(require("QuoteV2/Models/QuoteItemBuilders/QuoteProductItemBuilder"));
var PlanCardAddMenu = (function (_super) {
    __extends(PlanCardAddMenu, _super);
    function PlanCardAddMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleInsertLineItemByType = function (type) {
            var _a = _this.props, section = _a.section, item = _a.item;
            if (type === Types_1.QuoteItemType.Product) {
                var productToken = _this.quoteProductStore.productToken;
                section.addLineItems(QuoteProductItemBuilder_1.default.new()
                    .withToken(productToken)
                    .withProductItemProperties(_this.quoteProductStore.fetchedProductTokenItemProperties)
                    .forSectionDisplayMode(section.displayMode)
                    .build(), item.id);
                _this.quoteTelemetry.trackAddLineItem(type, section.displayMode, QuoteTelemetry_1.AddLineItemSource.Button, {
                    providerType: productToken.substitutionToken.providerType,
                    objectType: _this.quoteProductStore.objectType,
                });
            }
            else {
                var billingSchedule = section.groupByBillingSchedule && item instanceof QuoteItemStore_1.QuotePricedItemStore
                    ? item.billingSchedule
                    : {
                        type: Types_1.BillingScheduleType.Recurring,
                        frequency: Types_1.RecurringFrequency.Monthly,
                    };
                var cardDefaultSettings = {
                    billingSchedule: billingSchedule,
                    interactive: {
                        isOptional: true,
                        isQuantityOptional: item instanceof QuoteItemStore_1.QuotePricedItemStore ? item.isQuantityOptional : false,
                    },
                    token: undefined,
                    description: undefined,
                    featureList: undefined,
                };
                section.addLineItems(new ItemTypes_1.ItemFactory().templateQuoteItem(type, cardDefaultSettings), item.id);
                if (billingSchedule) {
                    _this.quoteTelemetry.trackBillingScheduleChange(billingSchedule);
                }
                _this.quoteTelemetry.trackAddLineItem(type, section.displayMode, QuoteTelemetry_1.AddLineItemSource.Button);
            }
        };
        _this.handleInsertSavedLineItems = function () {
            var _a = _this.props, section = _a.section, item = _a.item;
            _this.savedLineItemsLibrary.open(_this.quote.currency).then(function (itemsToInsert) {
                var clones = itemsToInsert.map(function (item) {
                    var _a;
                    var clone = (0, lodash_1.cloneDeep)(item);
                    if (section.itemSingleSelect && ((_a = clone.interactive) === null || _a === void 0 ? void 0 : _a.isOptional)) {
                        clone.interactive.isOptionalSelected = false;
                    }
                    return clone;
                });
                section.addLineItems(clones, item.id);
                clones.forEach(_this.quoteTelemetry.trackSavedLineItemInsertion);
            });
        };
        return _this;
    }
    Object.defineProperty(PlanCardAddMenu.prototype, "nonProductOptionsDisabled", {
        get: function () {
            var _a = this.props, section = _a.section, item = _a.item;
            return section.groupByBillingSchedule && item instanceof QuoteItemStore_1.QuoteProductItemStore;
        },
        enumerable: false,
        configurable: true
    });
    PlanCardAddMenu.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { autoStack: true, size: "small", button: react_1.default.createElement(kaleidoscope_1.IconButton, { isRound: true, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, tooltip: { content: "Add plan" }, icon: react_1.default.createElement(icons_1.Add, null) }) },
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.FixedCost, null), onClick: function () {
                    _this.handleInsertLineItemByType(Types_1.QuoteItemType.FixedCost);
                }, disabled: this.nonProductOptionsDisabled }, "Fixed cost"),
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.Variable, null), onClick: function () {
                    _this.handleInsertLineItemByType(Types_1.QuoteItemType.Variable);
                }, disabled: this.nonProductOptionsDisabled }, "Variable"),
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.Search, null), onClick: function () { return _this.handleInsertSavedLineItems(); }, disabled: this.nonProductOptionsDisabled }, "Saved plan"),
            react_1.default.createElement(QuoteProductLoader_1.QuoteProductLoader, { component: react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.Tokens, null), onClick: function () { return _this.handleInsertLineItemByType(Types_1.QuoteItemType.Product); } }, "Products"), state: this.quoteProductStore.status })));
    };
    var _a, _b, _c, _d;
    __decorate([
        (0, inversify_react_1.resolve)("savedLineItemsLibrary"),
        __metadata("design:type", typeof (_a = typeof SavedLineItemsLibrary_1.default !== "undefined" && SavedLineItemsLibrary_1.default) === "function" ? _a : Object)
    ], PlanCardAddMenu.prototype, "savedLineItemsLibrary", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_b = typeof QuoteBlockStore_1.default !== "undefined" && QuoteBlockStore_1.default) === "function" ? _b : Object)
    ], PlanCardAddMenu.prototype, "quote", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_c = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _c : Object)
    ], PlanCardAddMenu.prototype, "quoteTelemetry", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteProductStore_1.QuoteProductStore),
        __metadata("design:type", typeof (_d = typeof QuoteProductStore_1.QuoteProductStore !== "undefined" && QuoteProductStore_1.QuoteProductStore) === "function" ? _d : Object)
    ], PlanCardAddMenu.prototype, "quoteProductStore", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PlanCardAddMenu.prototype, "nonProductOptionsDisabled", null);
    PlanCardAddMenu = __decorate([
        mobx_react_1.observer
    ], PlanCardAddMenu);
    return PlanCardAddMenu;
}(react_1.default.Component));
exports.default = PlanCardAddMenu;
